/**
 * @desc 获取仓库类型
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.storageDamageMaster.getWarehouseType.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/storageDamageMaster/getWarehouseType`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
